import { buildAPIUrl } from '../utils/Gr8piConfig';

const API_END_POINT = buildAPIUrl();

export const ADDR_PREFIX = {
  ACCOUNT: 'account',
  RESPONDENT: 'res',
};

const RouterConst = {
  API_END_POINT,
  DOWNLOAD_RESPONDENT_TEMPLATE: '/import-templates/import-respondents.xlsx',
  DOWNLOAD_SURVEY_PROJECT_IMPORT_TEMPLATE: '/import-templates/import-surveys.xlsx',
  ROOT: '/',
  authDashboard: {
    endpoint: '/auth',
  },
  // dashboard
  dashboard: {
    pattern: '/accounts/:aid/dashboard',
    endpoint: '/dashboard',
  },

  // respondent
  respondents: {
    pattern: '/accounts/:aid/respondents',
    endpoint: '/respondents',
  },
  respondentDetail: {
    pattern: '/accounts/:aid/respondents/:respondentId',
  },
  respondentNew: {
    pattern: '/accounts/:aid/new-respondent',
    endpoint: '/respondents/new',
  },
  surveyRespondentDetail: {
    pattern: '/accounts/:aid/survey-respondent-detail/:surveyRespondentId',
  },

  // respondent importing
  respondentImp: {
    pattern: '/accounts/:aid/import-respondents',
    endpoint: '/import-respondents',
  },
  respondentImpDetail: {
    pattern: '/accounts/:aid/import-respondents/:importFileId',
  },

  // assessment
  assessments: {
    pattern: '/accounts/:aid/assessments',
    endpoint: '/assessments',
  },
  assessmentDetail: {
    pattern: '/accounts/:aid/assessments/:assessmentId',
  },
  assessmentNew: {
    pattern: '/accounts/:aid/respondents/:respondentId/new-assessment',
  },

  // assessment template
  asmtTemplates: {
    pattern: '/accounts/:aid/assessment-templates',
    endpoint: '/assessment-templates',
  },
  asmtTemplateNew: {
    pattern: '/accounts/:aid/new-assessment-template',
    endpoint: '/new-assessment-template',
  },
  asmtTemplateDetail: {
    pattern: '/accounts/:aid/assessment-templates/:templateId',
  },

  // job profile and job profile survey
  jp: {
    pattern: '/accounts/:aid/jp',
    endpoint: '/jp',
  },
  jpNew: {
    pattern: '/accounts/:aid/jp-new',
    endpoint: '/jp-new',
  },
  jpDetail: {
    pattern: '/accounts/:aid/jp/:jobProfileId',
  },
  jps: {
    pattern: '/accounts/:aid/jp/:jobProfileId/surveys',
  },
  jpsDetail: {
    pattern: '/accounts/:aid/jps-detail/:jpsRespondentId',
  },

  // superlink
  superlink: {
    pattern: '/accounts/:aid/super-links',
    endpoint: '/super-links',
  },
  superlinkDetail: {
    pattern: '/accounts/:aid/super-links/:superLinkId',
  },
  superlinkNew: {
    pattern: '/accounts/:aid/new-superlink',
    endpoint: '/new-superlink',
  },

  // super link import respondent
  superlinkResImport: {
    pattern: '/accounts/:aid/super-links/:superLinkId/import',
  },
  superlinkResImportDetail: {
    pattern: '/accounts/:aid/super-links/:superLinkId/import/:importFileId',
  },

  // survey
  surveys: {
    pattern: '/accounts/:aid/surveys',
    endpoint: '/surveys',
  },
  surveyDetail: {
    pattern: '/accounts/:aid/surveys/:surveyId',
  },
  surveyNew: {
    pattern: '/accounts/:aid/respondents/:respondentId/new-survey',
  },

  // survey template
  surveyTemps: {
    pattern: '/accounts/:aid/surveys/templates',
    endpoint: '/survey-templates',
  },
  surveyTempDetail: {
    pattern: '/accounts/:aid/surveys/templates/:templateId',
  },
  surveyTempNew: {
    pattern: '/accounts/:aid/surveys/template/new',
    endpoint: '/new-survey-template',
  },

  // survey project
  surveyProj: {
    pattern: '/accounts/:aid/survey-projects',
    endpoint: '/survey-projects',
  },
  surveyProjDetail: {
    pattern: '/accounts/:aid/survey-projects/:surveyProjectId',
  },
  surveyProjNew: {
    pattern: '/accounts/:aid/new-survey-project',
    endpoint: '/new-survey-project',
  },
  surveyProjImportDetail: {
    pattern: '/accounts/:aid/survey-projects/:surveyProjectId/import/:importId',
  },

  // executive report
  execReport: {
    pattern: '/accounts/:aid/executive-reports',
    endpoint: '/executive-reports',
  },
  execReportDetail: {
    pattern: '/accounts/:aid/executive-reports/:reportId',
  },
  execReportNew: {
    pattern: '/accounts/:aid/new-executive-report',
    endpoint: '/new-executive-report',
  },
  execReportImport: {
    pattern: '/accounts/:aid/executive-reports/:reportId/add-surveys',
  },

  // users
  users: {
    pattern: '/accounts/:aid/users',
    endpoint: '/users',
  },

  userInvite: {
    pattern: '/accounts/:aid/invite-user',
    endpoint: '/invite-user',
  },
  invitationList: {
    pattern: '/accounts/:aid/invitations',
    endpoint: '/invitations',
  },

  profile: {
    pattern: '/accounts/:aid/profile',
    endpoint: '/profile',
  },
  dataExport: {
    pattern: '/accounts/:aid/export',
    endpoint: '/export',
  },

  SUPER_LINK_IMPORT_FILE: '/c/super-link-import',
  PAGE_REPORT_URL: '/reports/download-reports',

  // developing
  DEV_ASMT_LIST: '/c/dev/assessments',
};

export default RouterConst;
